import * as React from "react";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";

import { IconButton } from "@mui/material";
import {
  DropDownList,
  DropDownListChangeEvent,
} from "@progress/kendo-react-dropdowns";
import { useTranslation } from "react-i18next";

/**
 *
 * @typedef {object} DropdownFilterCellProps
 * @prop {string} defaultItem
 * @prop {string[]} data
 */

/**
 *
 * @param {DropdownFilterCellProps& DropdownFilterCellProps} props
 * @returns
 */
export const DropDownFilterCell = (props) => {
  const { t } = useTranslation();
  let hasValue = (value) => Boolean(value && value !== props.defaultItem);

  /**
   *
   * @param {DropDownListChangeEvent} event
   */
  const onChange = (event) => {
    hasValue = hasValue(event.target.value);
    props.onChange({
      value: hasValue ? event.target.value.value.toLowerCase() : "",
      operator: hasValue ? "eq" : "",
      syntheticEvent: event.syntheticEvent,
    });
  };
  const data = React.useMemo(
    () => t(props.filterTKey, { returnObjects: true }),
    [props.filterTKey, t]
  );

  const onClearButtonClick = (event) => {
    event.preventDefault();
    props.onChange({
      value: "",
      operator: "",
      syntheticEvent: event,
    });
  };
  return (
    <div className="k-filtercell">
      <DropDownList
        data={data}
        dataItemKey="value"
        textField="text"
        onChange={onChange}
        value={
          data.find(
            (d) => d.value.toLowerCase() === props.value.toLowerCase()
          ) || null
        }
        defaultItem={props.defaultItem}
      />
      <IconButton
        disabled={!hasValue(props.value)}
        onClick={onClearButtonClick}
      >
        <FilterAltOffIcon />
      </IconButton>
    </div>
  );
};
